import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const NotFoundPage = () => {
  return (
    <Container className='text-center my-4'>
      <h4>404</h4>
      <a herf='#'>Page Not Found</a>
    </Container>
  )
}

export default NotFoundPage
